import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import { isLandingHost } from './site'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

/**
 * One build, two faces. A landing host loads only the landing bundle; every
 * other host loads the app. Both are split out with import(), so neither
 * downloads the other's code. See src/site.ts.
 */
const load = isLandingHost()
  ? import('./LandingRoot')
  : (() => {
      // public/index.html carries the landing page's title and search tags.
      // The app is behind a sign-in and should not be indexed on any host.
      document.title = 'MyHomeVault'
      const robots = document.createElement('meta')
      robots.name = 'robots'
      robots.content = 'noindex'
      document.head.appendChild(robots)
      // The demo brand must be applied before any app module evaluates —
      // styled-components bakes theme colors in at module load (see
      // bootstrapTheme.ts), so the theme fetch happens in this gap.
      return import('./bootstrapTheme')
        .then(({ bootstrapTheme }) => bootstrapTheme())
        .then(() => import('./AppRoot'))
    })()

load.then(({ default: Root }) =>
  root.render(
    <BrowserRouter>
      <Root />
    </BrowserRouter>,
  ),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
